import { gql } from '@apollo/client';

const ORDERWISE_INTEGRATION_FRAGMENT = gql`
    fragment OrderwiseIntegrationFields on OrderwiseIntegrationType {
        id
        createdAt
        fetchProgress
        masterDataUpdatedAt
        masterDataUpdateError
        masterDataUpdateActive
        name
        username
        baseUrl
        sessionId
        priceCheckLowerThresholdPercentage
        priceCheckUpperThresholdPercentage
        integrationParameters
        proxy
        attachmentsBaseUrl
        orderChannels {
            id
            name
        }
        rfqChannels {
            id
            name
        }
    }
`;

export const GET_ORDERWISE_INTEGRATIONS = gql`
    query OrderwiseIntegrations {
        orderwiseIntegrations {
            ...OrderwiseIntegrationFields
        }
    }
    ${ORDERWISE_INTEGRATION_FRAGMENT}
`;

export const GET_ORDERWISE_INTEGRATION_PARAMETER_DEFINITIONS = gql`
    query OrderwiseIntegrationParameterDefinitions {
        orderwiseIntegrationParameterDefinitions {
            key
            type
            default
            description
        }
    }
`;

export const CREATE_ORDERWISE_INTEGRATION = gql`
    mutation CreateOrderwiseIntegration(
        $name: String!
        $username: String!
        $password: String!
        $baseUrl: String!
        $sessionId: String!
        $priceCheckLowerThresholdPercentage: Float
        $priceCheckUpperThresholdPercentage: Float
        $integrationParameters: GenericScalar
        $proxy: String
        $attachmentsBaseUrl: String
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        createOrderwiseIntegration(
            name: $name
            username: $username
            password: $password
            baseUrl: $baseUrl
            sessionId: $sessionId
            priceCheckLowerThresholdPercentage: $priceCheckLowerThresholdPercentage
            priceCheckUpperThresholdPercentage: $priceCheckUpperThresholdPercentage
            integrationParameters: $integrationParameters
            proxy: $proxy
            attachmentsBaseUrl: $attachmentsBaseUrl
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...OrderwiseIntegrationFields
            }
        }
    }
    ${ORDERWISE_INTEGRATION_FRAGMENT}
`;

export const UPDATE_ORDERWISE_INTEGRATION = gql`
    mutation UpdateOrderwiseIntegration(
        $id: UUID!
        $name: String!
        $username: String!
        $password: String
        $baseUrl: String!
        $sessionId: String!
        $priceCheckLowerThresholdPercentage: Float
        $priceCheckUpperThresholdPercentage: Float
        $integrationParameters: GenericScalar
        $proxy: String
        $attachmentsBaseUrl: String
        $orderChannels: [UUID]
        $rfqChannels: [UUID]
    ) {
        updateOrderwiseIntegration(
            id: $id
            name: $name
            username: $username
            password: $password
            baseUrl: $baseUrl
            sessionId: $sessionId
            priceCheckLowerThresholdPercentage: $priceCheckLowerThresholdPercentage
            priceCheckUpperThresholdPercentage: $priceCheckUpperThresholdPercentage
            integrationParameters: $integrationParameters
            proxy: $proxy
            attachmentsBaseUrl: $attachmentsBaseUrl
            orderChannels: $orderChannels
            rfqChannels: $rfqChannels
        ) {
            integration {
                ...OrderwiseIntegrationFields
            }
        }
    }
    ${ORDERWISE_INTEGRATION_FRAGMENT}
`;

export const DELETE_ORDERWISE_INTEGRATION = gql`
    mutation DeleteOrderwiseIntegration($id: UUID!) {
        deleteOrderwiseIntegration(id: $id) {
            success
        }
    }
`;

export const TRIGGER_ORDERWISE_INTEGRATION_MASTERDATA_UPDATE = gql`
    mutation TriggerOrderwiseIntegrationMasterDataUpdate($id: UUID!) {
        triggerOrderwiseIntegrationMasterDataUpdate(id: $id) {
            started
        }
    }
`;
